import styled from 'styled-components';
import { EmptyButton, getTheme } from 'mol-ui';

export const ActionButton = styled(EmptyButton)`
    align-items: center;
    color: ${ getTheme('textColor') };
    display: flex;
    flex-direction: row;
    font-size: 15px;
    margin-bottom: 10px;
    width: max-content;
`;

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

export const Text = styled.span`
    margin: 0px 5px;
`;
